import {createSelector} from 'reselect/lib/index';
import {
  getExistingRMDinfo,
  getRMDAgreements
} from '../RMD/RMDSetting.selectors';

export const getExistingAutomatics = (state) => {
  return {
    autoExchanges: state.existingAutomatics.autoExchanges,
    autoSells: state.existingAutomatics.autoSells,
  };
};

export const getIsDisbursementType = createSelector(
  getExistingAutomatics,
  ({ autoExchanges, autoSells }) => {
    const autoExKey = Object.keys(autoExchanges);
    const autoSellKey = Object.keys(autoSells);
    const exchangeLE = autoExKey.filter(
      (key) =>
        autoExchanges[key][0].disbursementType &&
        autoExchanges[key][0].disbursementType.enumerationID === 11
    );
    const sellLE = autoSellKey.filter(
      (key) =>
        autoSells[key][0].disbursementType &&
        autoSells[key][0].disbursementType.enumerationID === 11
    );
    return exchangeLE.length > 0 || sellLE.length > 0;
  }
);

export const getAllSystematics = createSelector(
  getExistingAutomatics,
  getExistingRMDinfo,
  getRMDAgreements,
  ({ autoExchanges, autoSells }, rmdInfo, rmdAgreements) => {
    let autoExchange = [],
      autoSell = [];
    Object.keys(autoExchanges).forEach((key) => {
      autoExchange = [...autoExchange, ...autoExchanges[key]];
    });
    Object.keys(autoSells).forEach((key) => autoSell.push(autoSells[key][0]));
    autoExchange = autoExchange
      .filter((en) => en.disbursementType.enumerationID !== 11)
      .filter(
        (fund) =>
          !rmdInfo.some(
            (en) =>
              en.electionAgreementUniqueId1 ===
                fund.electionAgreementUniqueId1 &&
              en.electionAgreementUniqueId2 ===
                fund.electionAgreementUniqueId2 &&
              en.encryptedUniqueKey === fund.encryptedUniqueKey
          )
      );
    autoSell = autoSell
      .filter((en) => en.disbursementType.enumerationID !== 11)
      .filter((fund) => {
        return !rmdInfo.some(
          (en) => {
            return (en.electionAgreementUniqueId1 === fund.electionAgreementUniqueId1 &&
            en.electionAgreementUniqueId2 === fund.electionAgreementUniqueId2 &&
            en.encryptedUniqueKey === fund.encryptedUniqueKey);
          });
      });
    const autoSellPlusAccounts = autoSell?.map((fund) => {
      const fundExistsInAgreement = rmdAgreements?.filter((agreement) => {
        return fund.sourceAgreementKey.agreementID === agreement.agreementID
      });
      if(fundExistsInAgreement.length > 0) {
        return {
          ...fundExistsInAgreement[0],
          ...fund
        }
      } else return null;
    }).filter((fund) => fund !== null);

    const autoExchangePlusAccounts = autoExchange?.map((fund) => {
      const fundExistsInAgreement = rmdAgreements?.filter((agreement) => {
        return fund.sourceAgreementKey.agreementID === agreement.agreementID
      });
      if(fundExistsInAgreement.length > 0) {
        return {
          ...fundExistsInAgreement[0],
          ...fund
        }
      } else return null;
    }).filter((fund) => fund !== null);

    return { autoExchangePlusAccounts, autoSellPlusAccounts };
  }
);

export const doesExistingAutomaticsHaveSpecialPayee = createSelector(
  getAllSystematics,
  ({ autoExchange, autoSell }) => {
    const exchangeSpecial = autoExchange.some((fund) => { return fund.specialPayee});
    const sellSpecial = autoSell.some((fund) => { return fund.specialPayee});
    return exchangeSpecial || sellSpecial;
  }
);
